import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'ReplacePlaceholders', standalone: true})
export class ReplacePlaceholdersPipe implements PipeTransform {

    constructor() { }

    /**
     * Replaces placeholders in a text string given an object with the mappings.
     *
     * @example given the following text string: 'Hi, %USER_NAME%!', then:
     *          <p>{{ this.greet | ReplacePlaceholders:{ USER_NAME: 'Patrick' } }}
     *          will output: <p>Hi, Patrick!</p>
     *
     * @param text The text that contains the placeholders
     * @param placeholders The object with the string mappings
     * @returns
     */
    transform(text: string, placeholders: any): string {
        const regex = new RegExp(`%(${Object.keys(placeholders).join('|')})%`, 'g');

        return text.replace(regex, (matched) => {
            matched = matched.replace(/%/g, '');

            return placeholders[matched];
        });
    }
}
